import React, { useEffect, useState } from 'react';
import RpmLineChart from '../../rpm/tabs/rpmlinegraph';
import api from '../../api/api';
import CloseIcon from '@mui/icons-material/Close';
import { getPracticeId } from '../../config/practice';
const Alertsgraphs = ({ PatientID, isAlert, onClose }) => {
  const [bppData, setBppData] = useState({ resdata: [] });
  const [wlmData, setWlmData] = useState({ resdata: [] });
  const [dataLoading, setDataLoading] = useState(false);
  const practiseid = getPracticeId();
  const [selectedTab, setSelectedTab] = useState(0); // Default to BPP data

  useEffect(() => {
    if (isAlert && PatientID) {
      fetchBppData();
      fetchWlmData();
    }
  }, [PatientID, isAlert]);

  const fetchBppData = async () => {
    setDataLoading(true); // Set data loading to true
    try {
      const response = await api.post(`/v1/${practiseid}/patient/${PatientID}/rpm/bpp-master`, {});
      if (response.status === 200) {
        setBppData(response); // Assuming response data is an array of BPP readings
        console.log('Fetched BPP Data:', response);
      } else {
        setBppData({ resdata: [] }); // Reset to an empty array if the response is not successful
      }
    } catch (error) {
      console.log('Error fetching BPP data:', error);
      setBppData({ resdata: [] }); // Reset to an empty array in case of error
    }
  };

  // Fetch WLM data function
  const fetchWlmData = async () => {
    setDataLoading(true); // Set data loading to true
    try {
      const response = await api.post(`/v1/${practiseid}/patient/${PatientID}/rpm/wlm-master`, {});
      if (response.status === 200) {
        setWlmData(response); // Assuming response data is an array of WLM readings
        console.log('Fetched WLM Data:', response);
      } else {
        setWlmData({ resdata: [] }); // Reset to an empty array if the response is not successful
      }
    } catch (error) {
      console.log('Error fetching WLM data:', error);
      setWlmData({ resdata: [] }); // Reset to an empty array in case of error
    } finally {
      setDataLoading(false); // Set data loading to false
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
      <div className="bg-white rounded-xl w-[70%] relative flex flex-column">
        <div className='flex w-full justify-end p-2'>
        <button onClick={onClose}><CloseIcon/></button>

        </div>

        {/* Tabs Section */}
        <div className="flex justify-center mt-4">
          <button
            className={`px-8 py-2 font-semibold ${selectedTab === 0 ? 'bg-[#E17954] text-white' : 'bg-gray-200'}`}
            onClick={() => setSelectedTab(0)} // Select BPP tab
          >
            BPP 
          </button>
          <button
            className={`px-8 py-2 font-semibold ${selectedTab === 1 ? 'bg-[#E17954] text-white' : 'bg-gray-200'}`}
            onClick={() => setSelectedTab(1)} // Select WLM tab
          >
            WLM 
          </button>
        </div>
<div className="flex justify-center ">
        <div className="w-[80%] h-[30vh] lg:h-[50vh] flex justify-center  items-center mb-5">
          <RpmLineChart key={selectedTab} dataa={selectedTab === 0 ? bppData.data : wlmData.data} />
        </div>
        </div>
   
        {dataLoading ? (
          <div class="flex justify-center items-center py-10">
  <div class="w-8 h-8 border-4 border-t-transparent border-blue-500 border-solid rounded-full animate-spin"></div>
</div>
        ) : (
          <div className="overflow-x-auto rounded-lg lg:max-h-[23vh] max-h-[28vh] overflow-y-auto mb-10" style={{ scrollbarWidth: 'none' }}>
            {((selectedTab === 0 ? bppData.resdata : wlmData.resdata || []).length === 0) ? (
              <div className="text-center text-red-500 font-semibold mt-4">No Data Found</div>
            ) : (
              <table className="min-w-full border-collapse table-auto rounded">
                <thead className="bg-gray-50">
                  <tr className="rounded-xl">
                    <th className="border px-4 py-2 text-center text-[#71717A] text-sm font-semibold">Date</th>
                    {selectedTab === 0 ? (
                      <>
                        <th className="border px-4 py-2 text-center text-[#71717A] text-sm font-semibold">Systolic</th>
                        <th className="border px-4 py-2 text-center text-[#71717A] text-sm font-semibold">Diastolic</th>
                        <th className="border px-4 py-2 text-center text-[#71717A] text-sm font-semibold">Pulse</th>
                      </>
                    ) : (
                      <>
                        <th className="border px-4 py-2 text-center text-[#71717A] text-sm font-semibold">Weight</th>
                      </>
                    )}
                  </tr>
                </thead>
                <tbody>
                  {/* Ensure that resdata is an array before using .map */}
                  {(selectedTab === 0 ? bppData.resdata : wlmData.resdata || []).map((reading, index) => (
                    <tr key={index}>
                      <td className="border px-4 py-2 text-center text-[#09090B] text-[13px] font-semibold">{reading.datelabel}</td>
                      {selectedTab === 0 ? (
                        <>
                          <td className="border px-4 py-2 text-center text-[#E17954] text-[14px]">{reading.systolic}</td>
                          <td className="border px-4 py-2 text-center text-[#E17954] text-[14px]">{reading.diastolic || 'N/A'}</td>
                          <td className="border px-4 py-2 text-center text-[#2563EB] text-[14px]">{reading.pulse || 'N/A'}</td>
                        </>
                      ) : (
                        <>
                          <td className="border px-4 py-2 text-center text-[#E17954] text-[14px]">{reading.weight || 'N/A'}</td>
                        </>
                      )}
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default Alertsgraphs;
